import {
  showBusinessCard,
  showCooperationIntention,
  editContactInfo,
  editBusinessCard,
  editCooperationIntention,
  distributionShopItemList,
  distributionShopItemTop,
  distributionShopItemTopMove,
  importBaseItems,
  batchEditDistributionPrice,
  batchEditDistributionShopItem,
  distributionShopItemDetail, supplierPromotionShopItem,
  sharePromotionShopItem,
  sharePromotionShopCompanyInfo,
  hasErpItemInfo,
  queryShopSettingConf,
  updateShopSettingConf,
  defaultRecoverSet,
  exportOperateData,
  uploadOperateRequest,
  exportOperateDataResult,
  getItemReceiveAddressApi,
  editWxInfo
} from '@api/commodity/index.js';

// 名片展示
export function getShowBusinessCard(data) {
  return showBusinessCard(data).then(res => {
    if(res.result === 1) {
      return businessCardMap(res.data)
    }
    return false
  });
}

// 未登录时获取卡片和合作信息
export function getSharePromotionShopCompanyInfo(data) {
  return sharePromotionShopCompanyInfo(data).then((res) => {
    if (res.result === 1) {
      return shareBusinessCardMap(res.data);
    } else {
      return false;
    }
  });
}
export function shareBusinessCardMap(res) {
  return {
    ...res,
    video: res.video ? JSON.parse(res.video) : [],
    picture: res.picture ? res.picture.split(',') : [],
    majorPlatform: res.majorPlatform ? JSON.parse(res.majorPlatform) : [],
    distributionPlatform: res.distributionPlatform ? JSON.parse(res.distributionPlatform) : [],
    supplyAbilityInfo: cooperationIntentionMap(res.supplyAbilityInfo)
  }
}
export function businessCardMap(res) {
  return {
    ...res,
    video: res.video ? JSON.parse(res.video) : [],
    picture: res.picture ? res.picture : '',
    majorPlatform: res.majorPlatform ? JSON.parse(res.majorPlatform) : [],
    distributionPlatform: res.distributionPlatform ? JSON.parse(res.distributionPlatform) : [],
  }
}

// 合作意向展示
export function getShowCooperationIntention(data) {
  return showCooperationIntention(data).then(res => {
    if(res.result === 1) {
      return cooperationIntentionMap(res.data)
    }
    return false
  })
}

export function cooperationIntentionMap(res) {
  return {
    ...res,
    cooperationMode: res.cooperationMode ? res.cooperationMode?.split(',') : []
  }
}

// 修改联系人信息

export function getEditContactInfo(data) {
  return editContactInfo(data).then(res => {
    if(res.result === 1) {
      return true
    }
    return false
  })
}

// 修改微信信息
export function getEditWxInfo(data) {
  return editWxInfo(data).then(res => {
    if(res.result === 1) {
      return true
    }
    return false
  })
}

// 名片编辑
export function getEditBusinessCard(data) {
  return editBusinessCard(data).then(res => {
    if(res.result === 1) {
      return true
    }
    return false
  })
}
// 格式化小店列表数据
function _formatItem(item) {
  return {
    ...item,
    canPublishPlatform: item.canPublishPlatform ? JSON.parse(item.canPublishPlatform) : [],
    mainImages: item.mainImages ? JSON.parse(item.mainImages) : []
  }
}
// 获取小店商品列表
export function getShopItemList(data) {
  return distributionShopItemList(data).then(res => {
    if (res.result === 1) {
      let resp = {
        ...res.data,
        records: (res?.data?.records || []).map(_formatItem)
      }
      return resp
    }
    return false
  })
}
// 小店商品设置置顶
export function setShopItemTop(data) {
  return distributionShopItemTop(data).then(res => {
    if (res.result === 1) {
      return true
    }
    return false
  })
}

// 合作意向编辑
export function getEditCooperationIntention(data) {
  return editCooperationIntention(data).then(res=> {
    if(res.result == 1) {
      return true
    }
    return false
  })
}
// 小店置顶商品上下移
export function moveShopItemTop(data) {
  return distributionShopItemTopMove(data).then(res => {
    if (res.result === 1) {
      return true
    }
    return false
  })
}

// 商品中心导入
export function getImportBaseItems(data) {
  return importBaseItems(data).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
// 分销小店: 供销商-批量修改分销价接口
export function batchDistributionPrice(data) {
  return batchEditDistributionPrice(data).then(res => {
    if(res.result === 1) {
      return res.data || {}
    } else {
      false
    }
  })
}
// 分销小店: 供销商-批量修改修改商品运营数据
export function batchDistributionShopItem(data) {
    return batchEditDistributionShopItem(data).then(res => {
      if(res.result === 1) {
        return res.data || {}
      } else {
        false
      }
    })
}

// 格式化小店商品详情数据
function _formatItemDetai(data) {
  if (data.skuList && data.skuList.length > 0) {
    data.skuList = data.skuList.map((item) => {
      return {
        ...item,
        skuSpecifications: item.skuSpecifications
          ? JSON.parse(item.skuSpecifications)
          : [],
      };
    });
  }
  return {
    ...data,
    canPublishPlatform: data.canPublishPlatform
      ? JSON.parse(data.canPublishPlatform)
      : [],
    mainImages: data.mainImages ? JSON.parse(data.mainImages) : [],
    detailImages: data.detailImages ? JSON.parse(data.detailImages) : [],
    specificationNames: data.specificationNames
      ? JSON.parse(data.specificationNames)
      : [],
    specifications: data.specifications ? JSON.parse(data.specifications) : [],
    categoryIds: data.categoryIds ? data.categoryIds.split(",") : [],
  }
}

// 获取小店商品详情数据
export function getShopItemDetail(data) {
  return distributionShopItemDetail(data).then(res => {
    if (res.result === 1) {
      return _formatItemDetai(res.data)
    }
    return null
  })
}

// 获取小店商品详情数据
export function getSupplierShopItemDetail(data) {
  return supplierPromotionShopItem(data).then(res => {
    if (res.result === 1) {
      return _formatItemDetai(res.data)
    }
    return null
  })
}

// 获取供销商商品推广 - 供销商商品详情
export function getShareShopItemDetail(data) {
  return sharePromotionShopItem(data).then(res => {
    if (res.result === 1) {
      return _formatItemDetai(res.data)
    }
    return null
  })
}

// 判断分销商品是否存在ERP商品关联关系
export function getHasErpItemInfo(data) {
  return hasErpItemInfo(data).then(res => {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}

//导出运营数据
export function exportOperate(data) {
    return exportOperateData(data).then(res => {
      if (res.result === 1) {
          return true;
      }
      return false
    })
}
//导出商品运营数据结果查询
export function queryExportOperateDataResult(data) {
    return exportOperateDataResult(data).then(res => {
        debugger;
      if (res.result === 1) {
          return res.data;
      }
      return false
    })
}

//导入运营数据
export function uploadOperateData(data) {
    return uploadOperateRequest(data).then(res => {
      if (res.result === 1) {
        return true
      }
      return false
    })
}



//---------小店装饰--start-----
// 小店装饰配置缓存 (按 companyId 缓存)
const shopSettingConfCache = new Map();

// 获取小店装饰配置
export function getShopSettingConf(data) {
  if(!data.companyId) return;

  // 检查缓存
  if(shopSettingConfCache.has(data.companyId)) {
    return Promise.resolve(shopSettingConfCache.get(data.companyId));
  }

  return queryShopSettingConf(data).then(res => {
    if(res.result === 1) {
      const result = res.data || false;
      // 存入缓存
      shopSettingConfCache.set(data.companyId, result);
      return result;
    }
    return false
  })
}
// 保存小店装饰配置
export function saveSettingConf(data) {
  return updateShopSettingConf(data).then(res => {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}
// 小店装饰配置恢复默认
export function defaultRecover(data) {
  return defaultRecoverSet(data).then(res => {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}
//---------小店装饰--end-----
// 获取商品退款地址信息
export function getItemReceiveAddress(data) {
  return getItemReceiveAddressApi(data).then(res => {
    if(res.result === 1) {
      return res.data || false
    }
    this.$message.error(res.message || '获取售后地址失败!')
    return false
  })
}